import { defineStore } from 'pinia';
import { API } from '@/services';
import { GET_ACCOUNTS_QUERY } from '@/services/account/queries/account/index.js';
import { UPDATE_USER_PREFERENCES_MUTATION } from '@/services/user/mutations/user/index.js';

export const useAccountStore = defineStore({
  id: 'account',
  state: () => ({
    isLoading: false,
    accounts: [],
    activeAccount: null
  }),
  actions: {
    async getAccounts() {
      try {
        this.isLoading = true;
        const res = await API.sendQuery('/graphql/account', GET_ACCOUNTS_QUERY);

        if (res.data.data.accounts && res.data.data.accounts.length > 0) {
          this.accounts = res.data.data.accounts
            .map((account) => ({
              id: Number(account.id),
              name: account.name,
              type: account.type,
              image: account.image
            }))
            .sort((a, b) => {
              return a.name.localeCompare(b.name);
            });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },

    setAccounts(accounts) {
      this.accounts = accounts
        .map((account) => ({
          id: Number(account.id),
          name: account.name,
          type: account.type,
          image: account.image
        }))
        .sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
    },

    async setActiveAccount(account) {
      this.activeAccount = account;
      await API.sendQuery('/graphql/user', UPDATE_USER_PREFERENCES_MUTATION, {
        preferences: [
          {
            key: 'active_account',
            value: account ? JSON.stringify(account) : ''
          }
        ]
      });
    }
  }
});
